import React, { useState, useEffect } from 'react';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import vr from '../../../../utils/Verifiers';
import { has, set } from 'lodash';
import TablaRegistrosProyeccion from './TablaRegistrosProyeccion';

const ReporteProyeccion = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [semanas, setsemanas] = useState([]);
    const [flores, setflores] = useState([]);
    const [reporte, setreporte] = useState([]);
    const [subsecciones, setsubsecciones] = useState({});
    const [semanas_disponibles, setsemanas_disponibles] = useState([]);
    const [ranchos, setranchos] = useState([]);
    const [selecciones, setselecciones] = useState({ semana: "", semanas_incluidas: 8, rancho: "", tope: "" });
    const ncluidas = [2, 4, 8, 12, 16, 20];
    const topes_alcance_reporte = [
        { value: '', label: 'Todo' },
        { value: 'PROYECCION CONTEOS', label: 'Conteo de campo' },
        { value: 'PLAN CAMPO', label: 'Valores teóricos' },
    ]
    const [proyecciones, setproyecciones] = useState({ bloques: [], proyecciones: [], temperaturas: [] });
    const [proyeccion_filtrada, setproyeccion_filtrada] = useState([]);
    const [showPoyeccionDetalles, setshowPoyeccionDetalles] = useState(null);
    useEffect(() => {
        getReportes();
    }, []);

    const getReportes = async (semana = undefined, semanas_incluidas = 8, rancho = "", tope = "INVENTARIO CAMPO") => {
        const resp = await vr.getDataAPI("campo/v2/proyeccion/reporte", { semanas_incluidas, semana, rancho, tope }, setloader, setdialog);
        if (!resp || !resp.estatus) return;
        //setsemanas(resp.semanas);
        //setreporte(resp.data);
        //if (Array.isArray(resp.data)) setflores([]);
        //else setflores(Object.keys(resp.data).sort((a, b) => a.localeCompare(b)));
        setsubsecciones({});
        //setsemanas_disponibles(resp.semanas_disponibles || []);
        setselecciones({ semana: resp.semana_seleccionada ?? "", semanas_incluidas: resp.semanas_incluidas, rancho: rancho ?? "", tope: "" });
        setranchos(resp.ranchos || []);
        setproyecciones(resp.proyeccion || { bloques: [], proyecciones: [], temperaturas: [] });
        agruparProyecciones(resp?.proyeccion?.proyecciones ?? [], resp.semana_seleccionada ?? "", resp.semanas_incluidas, "");
    }

    const filtrarProyecciones = (
        proy = { ...proyecciones.proyecciones },
        semana_inicial = selecciones.semana,
        semanas_incluidas = selecciones.semanas_incluidas,
        tope = selecciones.tope
    ) => {
        let semanas = {};
        proy.map(p => {
            const semana = p.semana_proyeccion != 'n/a' ? p.semana_proyeccion : p.semana_cosecha;
            if (!semanas[semana]) {
                semanas[semana] = true;
            }
        });
        semanas = Object.keys(semanas).sort((a, b) => a.localeCompare(b));
        setsemanas_disponibles([...semanas].reverse());
        let indexInicio = semanas.indexOf(semana_inicial);
        if (indexInicio === -1) {
            indexInicio = Math.max(semanas.length - (semanas_incluidas + 1), 0);
        }
        let indexFin = indexInicio + semanas_incluidas;
        semanas = semanas.slice(indexInicio, indexFin);
        const hashSemanas = {};
        semanas.forEach(semana => {
            hashSemanas[semana] = true;
        });

        return proy.filter(p => {
            const semana = p.semana_proyeccion != 'n/a' ? p.semana_proyeccion : p.semana_cosecha;
            let topeCondicion = true;
            if (tope !== "" && p.fuente !== tope) {
                topeCondicion = false;
            }
            return hashSemanas[semana] && topeCondicion;
        });
    }

    const agruparProyecciones = (
        proy = { ...proyecciones.proyecciones },
        semana_inicial = selecciones.semana,
        semanas_incluidas = selecciones.semanas_incluidas,
        tope = selecciones.tope
    ) => {
        const filtradas = filtrarProyecciones(proy, semana_inicial, semanas_incluidas, tope);
        let hash = {};
        let len = filtradas.length;


        let semanas = {};
        for (let i = 0; i < len; i++) {
            const semana = filtradas[i].semana_proyeccion != 'n/a' ? filtradas[i].semana_proyeccion : filtradas[i].semana_cosecha;
            if (!semanas[semana]) {
                semanas[semana] = true;
            }
        }
        setsemanas(Object.keys(semanas).sort((a, b) => a.localeCompare(b)));

        let hashSemanas = {}
        Object.keys(semanas).sort((a, b) => a.localeCompare(b)).map(semana => {
            hashSemanas[semana] = 0;
            return semana;
        });

        for (let i = 0; i < len; i++) {
            const flor = filtradas[i].flor;
            const variedad = filtradas[i].variedad;
            const color = filtradas[i].color;
            const semana = filtradas[i].semana_proyeccion != 'n/a' ? filtradas[i].semana_proyeccion : filtradas[i].semana_cosecha;
            const fuente = filtradas[i].fuente;
            const tallos = filtradas[i].tallos_reales > 0 ? filtradas[i].tallos_reales : filtradas[i].tallos_teoricos ?? 0;
            if (!hash[flor]) {
                hash[flor] = {
                    flor: flor,
                    semanas: JSON.parse(JSON.stringify(hashSemanas)),
                    fuentes: [],
                    variedades: {}
                };
            }

            if (!hash[flor].semanas[semana]) {
                hash[flor].semanas[semana] = 0;
            }
            hash[flor].semanas[semana] += tallos;

            if (!hash[flor].fuentes.includes(fuente)) {
                hash[flor].fuentes.push(fuente);
            }

            if (!hash[flor].variedades[variedad]) {
                hash[flor].variedades[variedad] = {
                    variedad: variedad,
                    fuentes: [],
                    semanas: JSON.parse(JSON.stringify(hashSemanas)),
                    colores: {}
                };
            }
            if (!hash[flor].variedades[variedad].fuentes.includes(fuente)) {
                hash[flor].variedades[variedad].fuentes.push(fuente);
            }
            if (!hash[flor].variedades[variedad].semanas[semana]) {
                hash[flor].variedades[variedad].semanas[semana] = 0;
            }
            hash[flor].variedades[variedad].semanas[semana] += tallos;

            if (!hash[flor].variedades[variedad].colores[color]) {
                hash[flor].variedades[variedad].colores[color] = {
                    color: color,
                    fuentes: [],
                    semanas: JSON.parse(JSON.stringify(hashSemanas)),
                    registros: []
                }
            }
            if (!hash[flor].variedades[variedad].colores[color].fuentes.includes(fuente)) {
                hash[flor].variedades[variedad].colores[color].fuentes.push(fuente);
            }
            if (!hash[flor].variedades[variedad].colores[color].semanas[semana]) {
                hash[flor].variedades[variedad].colores[color].semanas[semana] = 0;
            }
            hash[flor].variedades[variedad].colores[color].semanas[semana] += tallos;
            hash[flor].variedades[variedad].colores[color].registros.push(filtradas[i]);
        }
        setflores(Object.keys(hash).sort((a, b) => a.localeCompare(b)));
        setreporte(hash);
    }

    const seleccionarFlor = (flor) => {
        const subs = { ...subsecciones };
        if (subsecciones[flor]) delete subs[flor];
        else subs[flor] = { variedades: Object.keys(reporte[flor].variedades), seleccionadas: {} };
        setsubsecciones(subs);
    }

    const seleccionarVariedad = (flor, variedad) => {
        const subs = { ...subsecciones };
        if (subsecciones[flor]?.seleccionadas[variedad]) {
            delete subsecciones[flor]?.seleccionadas[variedad];
        }
        else {
            const coloresVariedad = Object.keys(reporte[flor]?.variedades[variedad]?.colores ?? []);
            subsecciones[flor].seleccionadas[variedad] = { colores: coloresVariedad, seleccionadas: {} };
        }
        setsubsecciones(subs);
    }

    const formatoNumero = (val) => {
        let num = 0;
        try {
            num = parseFloat(val);
            if (isNaN(num)) return "0";
        } catch (error) {
            return "0";
        }
        return val.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    }

    return (
        <>
            <div className="w mt-1" style={{ '--w': '100%' }}>
                <div className='row justify-content-center w-100 m-0 p-0'>
                    <div className="w p-2 " style={{ '--w': '100%' }}>
                        <div className='row justify-content-end w-100 m-0 p-0'>
                            <div className="bw m-1" style={{ '--bw': '200px' }}>
                                <div className="w text-start text-xs text-bold" style={{ '--w': '100%' }}>Semana inicial</div>
                                <select className='form-control form-control-sm' placeholder='' onChange={(e) => {
                                    setselecciones({ ...selecciones, semana: e.target.value });
                                    agruparProyecciones(
                                        proyecciones.proyecciones,
                                        e.target.value,
                                        +selecciones.semanas_incluidas,
                                        selecciones.tope
                                    )
                                }} value={selecciones.semana}>
                                    {semanas_disponibles.map((sem, i) => (
                                        <option key={i} value={sem}>{sem}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="bw m-1" style={{ '--bw': '200px' }}>
                                <div className="w text-start text-xs text-bold" style={{ '--w': '100%' }}>Semanas incluidas</div>
                                <select className='form-control form-control-sm'
                                    onChange={(e) => {
                                        setselecciones({ ...selecciones, semanas_incluidas: +e.target.value });
                                        agruparProyecciones(
                                            proyecciones.proyecciones,
                                            selecciones.semana,
                                            +e.target.value,
                                            selecciones.tope
                                        );
                                    }}
                                    value={selecciones.semanas_incluidas}>
                                    {ncluidas.map((num, i) => (
                                        <option key={i + "eer"} value={num}>{num}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="bw m-1" style={{ '--bw': '350px' }}>
                                <div className="w text-start text-xs text-bold" style={{ '--w': '100%' }}>Alcance de la proyección</div>
                                <select className='form-control form-control-sm'
                                    onChange={(e) => {
                                        setselecciones({ ...selecciones, tope: e.target.value });
                                        agruparProyecciones(
                                            proyecciones.proyecciones,
                                            selecciones.semana,
                                            selecciones.semanas_incluidas,
                                            e.target.value
                                        );
                                    }}
                                    value={(selecciones.tope ?? '')}>
                                    {topes_alcance_reporte.map((tope, i) => (
                                        <option key={i + "tope"} value={tope.value}>{tope.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <table className='table table-sm table-hover'>
                        <thead>
                            <tr className='bg-dark text-m'>
                                <th scope='col' className='text-white bg-transparent'>FLOR</th>
                                <th scope='col' className='text-white bg-transparent'>Fuentes</th>
                                {semanas.map((sem, i) => (
                                    <th className='text-end text-white bg-transparent' key={i} scope='col'>{sem}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {flores.map((flor, i) => <React.Fragment key={i + "flor"}>
                                <tr className={`bg-${subsecciones[flor] ? 'black6' : 'white'} transition-xs pointer`} onClick={() => seleccionarFlor(flor)}>
                                    <th scope='row' className={`bg-transparent pt-3 ${flor === "TOTALES SEMANALES" ? 'bg-amber01' : ''}`}>{flor}</th>
                                    <th scope='row' className={`bg-transparent pt-3 text-xs text-500 ${flor === "TOTALES SEMANALES" ? 'bg-amber01' : ''}`}>{reporte[flor]?.fuentes?.join(", ")}</th>
                                    {semanas.map((sem, j) => (
                                        <td className={`text-end bg-transparent text-bold pt-3 ${sem === "TOTAL" || flor === "TOTALES SEMANALES" ? 'bg-amber01' : ''}`} key={j + sem + flor}>{formatoNumero(reporte[flor]?.semanas[sem] || 0)}</td>
                                    ))}
                                </tr>


                                {subsecciones[flor] && subsecciones[flor]?.variedades.map((variedad, k) =>
                                    <React.Fragment key={k + flor + variedad}>
                                        <tr className={`bg-${subsecciones[flor]?.seleccionadas[variedad] ? 'white5' : 'transparent'} transition-xs border-none pointer`} onClick={() => seleccionarVariedad(flor, variedad)}>
                                            <th scope='row' className='bg-transparent text-300 ps-3 text-blue2' >{variedad}</th>
                                            <th scope='row' className='bg-transparent text-xs text-500 ps-3 text-blue2' >{reporte[flor]?.variedades[variedad]?.fuentes?.join(", ")}</th>
                                            {semanas.map((sem, j) => (
                                                <td className={`text-end bg-transparent text-300 text-blue2 ${sem === "TOTAL" ? 'bg-amber01' : ' '}`} key={j + sem + flor + variedad}>
                                                    {formatoNumero(reporte[flor]?.variedades[variedad]?.semanas[sem] || 0)}
                                                </td>
                                            ))}
                                        </tr>

                                        {subsecciones[flor] &&
                                            subsecciones[flor].seleccionadas[variedad] &&
                                            subsecciones[flor].seleccionadas[variedad].colores.map((color, j) =>
                                                <React.Fragment key={j + flor + variedad + color}>

                                                    <tr className={`bg-white3 transition-xs pointer`} onClick={() => setshowPoyeccionDetalles(reporte[flor]?.variedades[variedad]?.colores[color]?.registros ?? [])}>
                                                        <td scope='row' className='bg-transparent ps-5 text-red2 border-bottom'>{color}</td>
                                                        <td scope='row' className='bg-transparent ps-5 text-xs text-500 text-red2 border-bottom'>{reporte[flor]?.variedades[variedad]?.colores[color]?.fuentes?.join(", ")}</td>
                                                        {semanas.map((sem, j) => (
                                                            <td className={`text-end bg-transparent border-bottom text-red2 ${sem === "TOTAL" ? 'bg-amber01' : ''}`} key={"ss" + j + sem + flor + variedad + color}>
                                                                {formatoNumero(reporte[flor]?.variedades[variedad]?.colores[color]?.semanas[sem] || 0)}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                </React.Fragment>)}

                                    </React.Fragment>)}

                            </React.Fragment>)}

                        </tbody>
                    </table>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
            {showPoyeccionDetalles && <TablaRegistrosProyeccion data={showPoyeccionDetalles} close={() => setshowPoyeccionDetalles(null)} />}
        </>
    )
}

export default ReporteProyeccion;